import { render, staticRenderFns } from "./ShippedArticlesStore.vue?vue&type=template&id=62195fa7&scoped=true"
import script from "./ShippedArticlesStore.vue?vue&type=script&lang=js"
export * from "./ShippedArticlesStore.vue?vue&type=script&lang=js"
import style0 from "./ShippedArticlesStore.vue?vue&type=style&index=0&id=62195fa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62195fa7",
  null
  
)

export default component.exports